import { render, staticRenderFns } from "./RumourList.vue?vue&type=template&id=1ad5108e"
import script from "./RumourList.vue?vue&type=script&lang=js"
export * from "./RumourList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ad5108e')) {
      api.createRecord('1ad5108e', component.options)
    } else {
      api.reload('1ad5108e', component.options)
    }
    module.hot.accept("./RumourList.vue?vue&type=template&id=1ad5108e", function () {
      api.rerender('1ad5108e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/rumour/RumourList.vue"
export default component.exports